import React from 'react';
import { dataIntelligence } from '../../mock';
import { Database } from 'lucide-react';

export default function DataIntel() {
  return (
    <section id="data" className="py-20 lg:py-32 bg-[#0F1C40] text-[#F1EDE4]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 lg:mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-white/50 mb-4">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span>Data Intelligence</span>
            </div>
            <h2 className="text-4xl lg:text-6xl tracking-tight leading-[1.02] font-medium">
              Data Intelligence <span className="font-serif italic font-normal">Platform.</span>
            </h2>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 bg-[#0F1C40] text-[#F1EDE4] rounded-2xl p-10 lg:p-12 flex flex-col justify-between min-h-[380px] reveal">
            <div>
              <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-white/50 mb-4">
                <Database className="w-3.5 h-3.5 text-[#4ECDC4]" />
                <span>Total Addressable Contacts · Globally</span>
              </div>
              <div className="text-8xl lg:text-9xl font-medium tabular tracking-tighter leading-none">
                {dataIntelligence.total}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 mt-8 pt-8 border-t border-neutral-800">
              <div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-1">1st-Party</div>
                <div className="text-2xl font-medium tabular">{dataIntelligence.firstParty.value}</div>
              </div>
              <div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-1">3rd-Party</div>
                <div className="text-2xl font-medium tabular">{dataIntelligence.thirdParty.value}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            <div className="bg-[#12234C] border border-white/10 rounded-2xl p-8 reveal">
              <div className="text-[10px] font-mono uppercase tracking-widest text-[#4ECDC4] mb-3">1st-Party</div>
              <div className="text-4xl font-medium tabular mb-2">{dataIntelligence.firstParty.value}</div>
              <div className="text-sm text-white/70 mb-6">{dataIntelligence.firstParty.desc}</div>
              <div className="pt-6 border-t border-white/10">
                <div className="text-[10px] font-mono uppercase tracking-wider text-white/50 mb-2">Data sources</div>
                <div className="text-sm font-medium">Proprietary verified records</div>
              </div>
            </div>
            <div className="bg-[#12234C] border border-white/10 rounded-2xl p-8 reveal">
              <div className="text-[10px] font-mono uppercase tracking-widest text-[#4ECDC4] mb-3">3rd-Party</div>
              <div className="text-4xl font-medium tabular mb-2">{dataIntelligence.thirdParty.value}</div>
              <div className="text-sm text-white/70 mb-6">{dataIntelligence.thirdParty.desc}</div>
              <div className="pt-6 border-t border-white/10">
                <div className="text-[10px] font-mono uppercase tracking-wider text-white/50 mb-2">Intent partners</div>
                <div className="flex flex-wrap gap-2">
                  {dataIntelligence.sources.map((s) => (
                    <span key={s} className="text-[11px] font-mono px-2 py-1 border border-white/15 rounded-full">{s}</span>
                  ))}
                </div>
              </div>
            </div>

            <div className="sm:col-span-2 bg-[#12234C] border border-white/10 rounded-2xl p-8 reveal">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <div className="text-[10px] font-mono uppercase tracking-widest text-white/50">Data pipeline health</div>
                  <div className="text-lg font-medium mt-1">Refreshed continuously · 96.1% accuracy</div>
                </div>
                <span className="flex items-center gap-2 text-xs font-mono">
                  <span className="w-2 h-2 rounded-full bg-emerald-500 pulse-dot" /> LIVE
                </span>
              </div>
              <div className="grid grid-cols-6 gap-1 mt-4">
                {Array.from({ length: 60 }).map((_, i) => (
                  <div key={i} className="h-6 rounded-sm" style={{ background: `hsl(${172 + (i % 4) * 4}, ${40 + (i % 5) * 12}%, ${50 + (i % 5) * 5}%)` }} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
